import { applyMiddleware, createStore } from 'redux';
import thunk from 'redux-thunk';

import rootReducer from './rootReducer';

const createStoreWithMiddleware = applyMiddleware(thunk)(createStore);

// tslint:disable-next-line: no-any
let devTools;
if (typeof window !== 'undefined') {
  // @ts-ignore
  devTools = window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__();
}

export default createStoreWithMiddleware(rootReducer, devTools);
